import { render, staticRenderFns } from "./PlatformNotificationsList.vue?vue&type=template&id=72b55e2d&"
import script from "./PlatformNotificationsList.vue?vue&type=script&lang=js&"
export * from "./PlatformNotificationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports